import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommitteeMemberSearchDto } from 'src/app/committees/shared/dto/committee-member-search.dto';

@Component({
  selector: 'wl-committee-members-search-params',
  templateUrl: './committee-members-search-params.component.html',
  styleUrls: ['./committee-members-search-params.component.less'],
    standalone: false
})
export class CommitteeMembersSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: CommitteeMemberSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<CommitteeMemberSearchDto> = new EventEmitter();

  private _searchParams: CommitteeMemberSearchDto;

  constructor() {
    this.searchParams = new CommitteeMemberSearchDto();
  }

  ngOnInit(): void {}
}
